export * from './lojas.store';
